/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import Box, { BoxProps } from '../Box/Box';
import { SxProp } from '../style/sxProp';

type PropsTypes = {
  fullScreenContents?: boolean;
};

const FULL_SCREEN_STYLE: Partial<SxProp> = {
  position: 'absolute',
  left: '-16px',
  right: '-16px',
  top: '12px',
};

const ContentFrame = <T extends keyof JSX.IntrinsicElements>({
  sx,
  as,
  children,
  fullScreenContents,
  ...boxProps
}: BoxProps<T> & PropsTypes): React.ReactElement => {
  const boxSx = useMemo(
    () => ({
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      boxSizing: 'border-box',
      overflowY: 'auto',
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
        {
          width: '432px',
        },
      ...(fullScreenContents ? FULL_SCREEN_STYLE : {}),
      ...(sx as any),
    }),
    [fullScreenContents, sx]
  );

  return (
    <Box as={as} sx={boxSx} {...boxProps}>
      {children}
    </Box>
  );
};

export default ContentFrame;
